import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveSeo } from '@/seo/seoData';

/**
 * Injects Schema.org JSON-LD for the current route. Kept separate from the
 * OG/Twitter head manager so structured data is managed independently.
 */
export default function JsonLd() {
  const location = useLocation();

  useEffect(() => {
    document.head
      .querySelectorAll('script[data-seo-json-ld]')
      .forEach((node) => node.remove());

    const seo = resolveSeo(location.pathname);
    if (!seo.jsonLd || seo.jsonLd.length === 0) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.dataset.seoJsonLd = 'true';
    script.text = JSON.stringify(seo.jsonLd);
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [location.pathname]);

  return null;
}